import { render } from "./editStatus.vue?vue&type=template&id=f3c460a2"
import script from "./editStatus.vue?vue&type=script&lang=js"
export * from "./editStatus.vue?vue&type=script&lang=js"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__